<template>
  <div class="base-drag-and-drop text-center">
    <div>
      <VueFileAgent
        ref="dragAndDropRef"
        v-model="files"
        :accept="uploadConfiguration.acceptFiles"
        :deletable="uploadConfiguration.deletable"
        :meta="true"
        :multiple="uploadConfiguration.multiple"
        :max-size="uploadConfiguration.maxSizeFile"
        :max-files="uploadConfiguration.maxFiles"
        :help-text="helpText"
        :error-text="errorText"
        theme="list"
        @select="onSelect($event)"
        @beforedelete="onDeleteFile($event)"
      />

      <BaseButton
        v-if="hasFileInDragAndDrop && integrationId"
        color="primary"
        class="mt-6"
        :is-disabled="disableUploadButton"
        @click="onUpload"
      >
        Enviar
      </BaseButton>
    </div>
    <BaseSnackbar
      :active-snackbar="feedback"
      :type-snackbar="feedbackColor"
      :text-snackbar="feedbackMessage"
      @closeSnackbar="feedback = !feedback"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { utilsShowErrorInDevelopmentEnvironment } from '../utils'
import BaseSnackbarConfiguration from '../mixins/BaseSnackbarConfiguration'
import BaseSnackbar from './BaseSnackbar'

export default {
  name: 'BaseDragAndDrop',
  components: {BaseSnackbar},
  mixins:[ BaseSnackbarConfiguration ],
  props: {
    uploadConfiguration: {
      type: Object,
      default: () => {
        return {
          acceptFiles: "",
          deletable: true,
          multiple: false,
          maxSizeFile: "",
          maxFiles: "1"
        }
      }
    },
    integrationId: {
      type: String,
      required: false,
      default: null
    },
    uploadPath: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      files: [],
      disableUploadButton: false,
      hasFileInDragAndDrop: false,
      helpText: 'Clique ou arraste e solte um novo arquivo aqui',
      errorText: {
        type: 'O arquivo deve ser do formato especificado',
        size: `O tamanho máximo do arquivo deve ser de ${this.uploadConfiguration.maxSizeFile}`
      }
    }
  },
  watch:{
    uploadPath(){
      if(this.files.length > 0)
        this.uploadToPath()
    }
  },
  methods: {
    ...mapActions(['apiGetProgramIntegrations', 'apiUploadIntegration', 'apiUploadMutantConfig']),
    onSelect(event) {
      this.disableUploadButton = false
      this.validateFiles(event)
      this.hasFileInDragAndDrop = true
    },
    validateFiles(files) {
      files.forEach(file => {
        if(file.error !== false) {
          this.disableUploadButton = true
          return
        }
      })
    },
    async onUpload() {
      if(this.files.length > 0) {
        try{
          for (let i = 0; i < this.files.length; i++) {
            let formData = new FormData()
            formData.append('file', this.files[i].file)
            await this.apiUploadIntegration({id: this.integrationId, type: 'upload', formData})
          }
          this.showFeedback({
            message: 'Arquivo enviado. Confira o resultado do processamento em seu e-mail.',
            color: 'info'
          })
        }catch(err) {
          utilsShowErrorInDevelopmentEnvironment(err)
          this.showFeedback({
            message: 'Ocorreu um erro ao cadastrar o arquivo.',
            color: 'error'
          })
        }finally {
          this.files = []
          this.hasFileInDragAndDrop = false
        }
      }
    },
    onDeleteFile(file) {
      const index = this.files.findIndex(element => element.lastModified === file.lastModified)
      this.files.splice(index, 1)
      if(this.files.length == 0) {
        this.hasFileInDragAndDrop = false
      }
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    async uploadToPath() {
      try {
        for (let i = 0; i < this.files.length; i++) {
          const fileBase64 = await this.fileToBase64(this.files[i].file);
          if(this.files[i].file.type){
            await this.apiUploadMutantConfig({
              "path": `${this.uploadPath}/${this.files[i].file.name}`,
              "content": fileBase64.split(',')[1]
            })
            this.$emit('onUpload', true)
          } else {
            this.$emit('onUpload', false, 'Arquivo não possui extensão.')
          }
        }
      } catch(err) {
        utilsShowErrorInDevelopmentEnvironment(err)
        this.$emit('onUpload', false)
      } finally {
        this.files = []
        this.hasFileInDragAndDrop = false
      }
    }
  }
}
</script>

<style scoped>

.base-drag-and-drop >>> .vue-file-agent  {
  width: 440px;
  margin-inline: auto;
}

</style>
